(function(angular, module) {var loadTag, makeState, states, tagViewController;

tagViewController = function($state, program, tag) {
  'ngInject';
  this.program = program;
  this.tag = tag;
  this.onDelete = function() {
    return $state.go('^.index');
  };
};

loadTag = function($stateParams, TagService, program) {
  'ngInject';
  return TagService.get($stateParams.tagId);
};

makeState = function(resolves) {
  return {
    url: '/{tagId:int}',
    templateUrl: 'tags/view',
    resolve: resolves,
    controller: tagViewController,
    controllerAs: 'tagView'
  };
};

states = function($stateProvider) {
  'ngInject';
  $stateProvider.state('tag.view', makeState({
    program: function() {
      return null;
    },
    tag: loadTag
  }));
  return $stateProvider.state('program.tag.view', makeState({
    tag: loadTag
  }));
};

module.config(states);
})(angular, angular.module("dybTags"));